import React, { useState } from "react";
import ReactPaginate from "react-paginate";
import { GrFormPrevious, GrFormNext } from "react-icons/gr";

const CustomPagination = ({
  totalTabs,
  tabsPerPage,
  handleChange,
  className,
}) => {
  const [currentPage, setCurrentPage] = useState(0);

  const handlePageClick = (selectedPage) => {
    // console.log("%c Line:9 🍪 selectedPage", "color:#ed9ec7", selectedPage);
    setCurrentPage(selectedPage.selected);
    handleChange(selectedPage.selected + 1);
  };

  const totalPages = Math.ceil(totalTabs / tabsPerPage);

  return (
    <div className={`pagination-div  ${className}`}>
      <ReactPaginate
        pageCount={totalPages}
        pageRangeDisplayed={3}
        marginPagesDisplayed={1}
        breakLabel={"..."}
        onPageChange={handlePageClick}
        containerClassName={"battery-Pagination"}
        activeClassName={"battery-Pagination-active"}
        previousLabel={
          <GrFormPrevious style={{ width: "22px", height: "22px" }} />
        }
        nextLabel={<GrFormNext style={{ width: "22px", height: "22px" }} />}
      />
    </div>
  );
};

export default CustomPagination;
